module.exports = __webpack_public_path__ + "img/健康_health.4160c473.svg";